import React from "react";
import { StateNavigator, HTML5HistoryManager } from "navigation";
import { NavigationHandler, SceneView } from "navigation-react";
import HomePage from "./HomePage";
import ProductDetails from "./ProductDetails";
import AboutPage from "./AboutPage";
import ContactPage from "./ContactPage";
import ServicePage from "./ServicePage";
import ChemicalsPage from "./ChemicalsPage";
import DoorSecurityPage from "./DoorSecurityPage";
import LabEquipmentPage from "./LabEquipmentPage";
import LoToPage from "./LoToPage";
import PpePage from "./PpePage";
import PadlockPage from "./PadlockPage";
import PumpAccessoriesPage from "./PumpAccessoriesPage";
import PumpsPage from "./PumpsPage";
import TorchlightPage from "./TorchlightPage";
import CctvPage from "./CctvPage";

const stateNavigator = new StateNavigator(
  [
    { key: "home", route: "" },
    { key: "productdetails", route: "products/{category}/{productslug}" },
    { key: "aboutpage", route: "/about" },
    { key: "contactpage", route: "/contact" },
    { key: "servicepage", route: "/services/mining-mineral-processing" },
    { key: "cctvpage", route: "/product/category/cctv" },
    { key: "chemicalspage", route: "/product/category/chemicals" },
    { key: "doorsecuritypage", route: "/product/category/door-security" },
    { key: "labconsumablespage", route: "/product/category/lab-equipment-consumables" },
    { key: "lotooccupationalpage", route: "/product/category/loto-occupational-safety" },
    { key: "ppepage", route: "/product/category/ppe" },
    { key: "padlockpage", route: "/product/category/padlock" },
    { key: "pumpaccessoriespage", route: "/product/category/pump-accessories-spare-parts" },
    { key: "pumpspage", route: "/product/category/pumps" },
    { key: "torchlightpage", route: "/product/category/torchlight" },
  ],
  
  new HTML5HistoryManager()
);

stateNavigator.start();

function App() {
  return (
    <NavigationHandler stateNavigator={stateNavigator}>
      <SceneView active="home">
        <HomePage />
      </SceneView>
      <SceneView active="productdetails"><ProductDetails /></SceneView>
      <SceneView active="aboutpage"><AboutPage /></SceneView>
      <SceneView active="contactpage"><ContactPage /></SceneView>
      <SceneView active="servicepage"><ServicePage /></SceneView>
      <SceneView active="cctvpage"><CctvPage /></SceneView>
      <SceneView active="chemicalspage"><ChemicalsPage /></SceneView>
      <SceneView active="doorsecuritypage"><DoorSecurityPage /></SceneView>
      <SceneView active="labconsumablespage"><LabEquipmentPage /></SceneView>
      <SceneView active="lotooccupationalpage"><LoToPage /></SceneView>
      <SceneView active="ppepage"><PpePage /></SceneView>
      <SceneView active="padlockpage"><PadlockPage /></SceneView>
      <SceneView active="pumpaccessoriespage"><PumpAccessoriesPage /></SceneView>
      <SceneView active="pumpspage"><PumpsPage /></SceneView>
      <SceneView active="torchlightpage"><TorchlightPage /></SceneView>
    </NavigationHandler>
  );
}

export default App;